// 静态资源服务器配置
export const STATIC_SERVER_BASE_URL = 'https://www.exposomex.cn'

// 下载路径
export const DOWNLOAD_PATHS = {
  web: '/exposome/Downloadweb/',
  video: '/exposome/DownloadVedio/',
  pdf: '/exposome/Downloadpdf/',
  demoV100: '/exposome/DownloadDemoV100/',
  demoV101: '/exposome/DownloadDemoV101/'
}

// 获取完整下载URL
export function getDownloadUrl(type, filename) {
  const path = DOWNLOAD_PATHS[type] || ''
  return `${STATIC_SERVER_BASE_URL}${path}${filename}`
}
